import { HeaderLabelType } from '@/modules/corporate/modules/admin/components/Header/types';
import {
  ActionItemEntityFilter,
  ProviderType,
  UserType,
  UserViewFieldSchema,
} from '@/types/schema';

import { DashboardActionsDispatch } from '../../hooks/useDashboardActions';
import useFile from '../../hooks/useFile';
import { UseTasksDashboardReturnType } from '../../hooks/useTasksDashboard';
import { getEmptyStateProps } from '../List/utils';
import { TaskViews } from '../TaskViewSelector';

export type FilterManagerConfig = {
  queryParamPrefix?: string;
  persistanceId: string; // uniqueId to distinguish between same entities
};

export interface DashboardProps {
  label?: HeaderLabelType;
  inViewFile?: NonNullable<ReturnType<typeof useFile>['file']>;
  entity?: ActionItemEntityFilter;
  entityName?: string;
  defaultAssigneeId?: string;
  participants?: UserType[];
  defaultEmptyStateProps?: ReturnType<typeof getEmptyStateProps>;
  taskView: TaskViews;
  taskViewConfig: UserViewFieldSchema[];
  fetching?: boolean; // used to block render untin taskViewConfig is fetched
  dispatch: DashboardActionsDispatch;
  className?: string;
  onRefetchParentProgress?: () => void;
  disableAddTask?: boolean;
  scrollElement?: Element | (Window & typeof globalThis) | undefined;
  addTasksViaAI?: boolean;
  taskDashboardProps: UseTasksDashboardReturnType;
  providers: ProviderType[];
  provider?: ProviderType;
}

export interface DashboardRef {
  refetch?: () => void;
}

export enum TaskDashboardTabs {
  MyTasks = 'my-tasks',
  TeamTasks = 'team-tasks',
  AllTasks = 'all-tasks',
}

export enum ListActions {
  Edit = 'EDIT',
  Delete = 'DELETE',
  Duplicate = 'DUPLICATE',
  ManageSyncedTasks = 'MANAGE_SYNCED_TASKS',
}

export enum TaskGroupByEnum {
  Status = 'status',
  Priority = 'priority',
  Assignee = 'assignedToId',
  DueDate = 'dueDate',
  Stage = 'stageIds',
}
